"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _ProductPrice = _interopRequireDefault(require("./ProductPrice"));

var _ProductQty = _interopRequireDefault(require("./ProductQty"));

var _TotalPrice = _interopRequireDefault(require("./TotalPrice"));

var _Description = _interopRequireDefault(require("./Description"));

var _Paper = _interopRequireDefault(require("@mui/material/Paper"));

var _DeleteButton = _interopRequireDefault(require("./DeleteButton"));

var _Removed = _interopRequireDefault(require("./Removed"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var styles = {
  label: {
    textAlign: 'right',
    padding: '0px'
  },
  value: {
    textAlign: 'right',
    padding: '0px'
  },
  row: {
    paddingTop: '5px',
    paddingRight: '10px'
  }
};

var ProductRow = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(ProductRow, _Component);

  var _super = _createSuper(ProductRow);

  function ProductRow() {
    var _this;

    (0, _classCallCheck2["default"])(this, ProductRow);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "updateCart", function (newValue) {
      _this.props.updateCart(_this.props.number, newValue);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "removeItem", function () {
      _this.props.removeItem(_this.props.number, _this.props.index);
    });
    return _this;
  }

  (0, _createClass2["default"])(ProductRow, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          name = _this$props.name,
          number = _this$props.number,
          qty = _this$props.qty,
          price = _this$props.price,
          special = _this$props.special,
          coupon = _this$props.coupon,
          couponCode = _this$props.couponCode,
          loading = _this$props.loading,
          updateCart = _this$props.updateCart,
          changePage = _this$props.changePage,
          removed = _this$props.removed,
          _this$props$file = _this$props.file,
          path = _this$props$file.path,
          thumbnail = _this$props$file.thumbnail,
          index = _this$props.index,
          label = _this$props.label,
          deletable = _this$props.deletable,
          editable = _this$props.editable,
          href = _this$props.href,
          coreCharge = _this$props.coreCharge,
          showStockStatus = _this$props.showStockStatus,
          qoh = _this$props.qoh;

      if (removed) {
        return /*#__PURE__*/_react["default"].createElement(_Removed["default"], {
          number: number,
          name: name,
          qty: qty,
          updateCart: updateCart,
          href: href
        });
      }

      var imgSrc = path + thumbnail;
      return /*#__PURE__*/_react["default"].createElement(_Paper["default"], {
        className: "container-fluid",
        style: {
          marginBottom: '15px',
          paddingBottom: '5px',
          paddingTop: '5px'
        }
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "row"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "col-md-1 hidden-sm hidden-xs",
        style: {
          margin: '5px 0 0 0',
          padding: '0 0 0 5px'
        }
      }, /*#__PURE__*/_react["default"].createElement(Image, {
        style: {
          width: '100%',
          height: 'auto'
        },
        src: imgSrc
      })), /*#__PURE__*/_react["default"].createElement("div", {
        className: "col-md-5 col-xs-12"
      }, /*#__PURE__*/_react["default"].createElement(_Description["default"], {
        coupon: coupon,
        code: couponCode,
        special: special,
        name: name,
        number: number,
        label: label,
        href: href,
        changePage: changePage,
        removeItem: this.removeItem,
        deletable: deletable,
        coreCharge: coreCharge
      })), /*#__PURE__*/_react["default"].createElement("div", {
        className: "hidden-sm hidden-xs"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "col-sm-2",
        style: {
          marginTop: '0'
        }
      }, /*#__PURE__*/_react["default"].createElement(_ProductQty["default"], {
        qty: qty,
        showStockStatus: showStockStatus,
        qoh: qoh === null || qoh === void 0 ? void 0 : qoh.toJS(),
        updateCart: this.updateCart,
        loading: loading,
        editable: editable
      })), /*#__PURE__*/_react["default"].createElement("div", {
        className: "col-sm-2",
        style: {
          marginTop: '8px'
        }
      }, /*#__PURE__*/_react["default"].createElement(_ProductPrice["default"], {
        price: price,
        special: special,
        coupon: coupon,
        coreCharge: coreCharge
      })), /*#__PURE__*/_react["default"].createElement("div", {
        className: "col-sm-1",
        style: {
          marginTop: '8px'
        }
      }, /*#__PURE__*/_react["default"].createElement(_TotalPrice["default"], {
        price: price,
        qty: qty,
        special: special,
        coupon: coupon,
        coreCharge: coreCharge
      })), /*#__PURE__*/_react["default"].createElement("div", {
        className: "hidden-sm hidden-xs col-sm-1"
      }, /*#__PURE__*/_react["default"].createElement(_DeleteButton["default"], {
        onClick: this.removeItem,
        deletable: deletable,
        disabled: loading,
        style: {
          marginTop: '-5px'
        }
      })))), /*#__PURE__*/_react["default"].createElement("div", {
        className: "hidden-lg hidden-md"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "row"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "col-xs-6"
      }, /*#__PURE__*/_react["default"].createElement(Image, {
        style: {
          width: '100%',
          height: 'auto'
        },
        src: imgSrc
      })), /*#__PURE__*/_react["default"].createElement("div", {
        className: "col-xs-6"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "row",
        style: _objectSpread({}, styles.row)
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "col-xs-4",
        style: _objectSpread({}, styles.label)
      }, /*#__PURE__*/_react["default"].createElement("p", null, "Qty: ")), /*#__PURE__*/_react["default"].createElement("div", {
        className: "col-xs-8",
        style: styles.value
      }, /*#__PURE__*/_react["default"].createElement(_ProductQty["default"], {
        qty: qty,
        updateCart: this.updateCart,
        loading: loading,
        editable: editable
      }))), /*#__PURE__*/_react["default"].createElement("div", {
        className: "row",
        style: styles.row
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "col-xs-4",
        style: styles.label
      }, /*#__PURE__*/_react["default"].createElement("p", null, "Price: ")), /*#__PURE__*/_react["default"].createElement("div", {
        className: "col-xs-8",
        style: styles.value
      }, /*#__PURE__*/_react["default"].createElement(_ProductPrice["default"], {
        price: price,
        coreCharge: coreCharge,
        special: special
      }))), /*#__PURE__*/_react["default"].createElement("div", {
        className: "row",
        style: styles.row
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "col-xs-4",
        style: styles.label
      }, /*#__PURE__*/_react["default"].createElement("p", null, "Total: ")), /*#__PURE__*/_react["default"].createElement("div", {
        className: "col-xs-8",
        style: styles.value
      }, /*#__PURE__*/_react["default"].createElement(_TotalPrice["default"], {
        price: price,
        qty: qty,
        coreCharge: coreCharge,
        special: special
      })))))));
    }
  }]);
  return ProductRow;
}(_react.Component);

exports["default"] = ProductRow;

function Image(props) {
  var _React$useState = _react["default"].useState(false),
      _React$useState2 = (0, _slicedToArray2["default"])(_React$useState, 2),
      error = _React$useState2[0],
      setError = _React$useState2[1];

  _react["default"].useEffect(function () {
    setError(false);
  }, [props.src]);

  if (error) {
    return /*#__PURE__*/_react["default"].createElement("img", (0, _extends2["default"])({}, props, {
      src: "/img/NoImage.png"
    }));
  }

  return /*#__PURE__*/_react["default"].createElement("img", (0, _extends2["default"])({}, props, {
    onError: function onError() {
      return setError(true);
    }
  }));
}